import React from "react";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { Field, getFormValues, reduxForm } from "redux-form";
import FutureDatepicker from "../../../commonfields/FutureDatePicker";
import SelectField from "../../../commonfields/SelectField";
import TextField from "../../../commonfields/TextField";
import stateNames from "../../../data/stateNames.json";
import FileUpload from "../../../commonfields/FileUpload";
import SelectButtonField2 from "../../../commonfields/SelectButtonField2";
import "./productsTab.scss";
import validate from "../../../Validate/EditProductValidate";
import normaliseDollar from "../../../utils/normaliseDollar";

interface IActionItemsFormProps {
  handleActionItemSave: (values: FormData) => void;
  InitialValues?: object;
}

const EditProductForm: React.FC = (props: any) => {
  const { handleActionItemSave } = props;
  const percentToSale = [
    {
      id: 0,
      text: "25%",
      value: "25%",
    },
    {
      id: 1,
      text: "50%",
      value: "50%",
    },
    {
      id: 2,
      text: "75%",
      value: "75%",
    },
  ];

  return (
    <form
      onSubmit={props.handleSubmit(handleActionItemSave)}
      className="productItemForm edit-product-form"
    >
      {" "}
      <div className="actionItemContainer container">
        <Row className="action-row">
          <Col md={6}>
            <Field
              component={SelectField}
              name="product"
              label={"Product"}
              values={props.productsDataOptions}
              disabled={props.disableProduct}
              isRequired={true}
            />
          </Col>
          <Col md={6}>
            <Field
              component={TextField}
              name="estimatedValue"
              type="text"
              minlength={0}
              label={"Estimated Value"}
              normalize={normaliseDollar}
            />
          </Col>
        </Row>

        <Row className="second-row">
          <Col md={6} className="contact">
            <Field
              component={SelectButtonField2}
              name="percentageToSale"
              label={"Percent to Sale"}
              values={percentToSale}
            />
          </Col>
          <Col md={6}>
            <span>Expected Close</span>
            <Field
              component={FutureDatepicker}
              name="expectedClose"
              label={"Expected Close"}
              minDate={new Date()}
            />
          </Col>
        </Row>
      </div>
      <div className="submit-btn">
        <Button color="primary-color" disabled={props.invalid}>
          save
        </Button>
      </div>
    </form>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    initialValues: props?.initalData,
    formValues: getFormValues("EditProductForm")(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "EditProductForm", // a unique identifier for this form
    enableReinitialize: true,
    touchOnChange: true,
    validate,
  })(EditProductForm)
);
